'use strict';

class FormStyling {

    constructor() {

        const formSetup = ( form, formContainer ) => {

            // Return if form is empty
            const formRows = document.querySelectorAll( formContainer + ' .mktoForm .mktoFormRow' );
            if ( !formRows ) return;

            // Pairs of fields that can be styled to be side by side
            let isFirstName, isLastName, isCurrentErp, isSwitchingTo, isSeniorityLevel, isDepartment;

            for ( const row of formRows ) {

                let formElement = row.querySelector( '.mktoFormCol .mktoField' );

                // Hide row that contains a hidden form element
                let hiddenFormElement = row.querySelector( 'input[type=hidden]' );
                if ( hiddenFormElement && hiddenFormElement.getAttribute( 'type' ) === 'hidden' ) {
                    row.classList.add( 'hide' );
                }

                // Set focus and blur effect for text inputs
                if ( formElement && formElement.getAttribute( 'type' ) !== 'checkbox' && formElement.tagName !== 'SELECT' ) {

                    formElement.addEventListener( 'focus', () => {
                        const elem = row;
                        let labelForElement = elem.querySelector( 'label' );
                        if ( labelForElement ) labelForElement.classList.add( 'focus' );
                    } );

                    formElement.addEventListener( 'blur', () => {
                        if ( formElement.value !== '' ) return false;
                        const elem = row;
                        let labelForElement = elem.querySelector( 'label' );
                        if ( labelForElement ) labelForElement.classList.remove( 'focus' );
                    } );

                }

                // Set focus and blur for selects
                if ( formElement && formElement.tagName === 'SELECT' ) {

                    formElement.addEventListener( 'change', () => {
                        const elem = row;
                        let labelForElement = elem.querySelector( 'label' );

                        if ( labelForElement ) {

                            if ( formElement.options.selectedIndex !== -1 ) {
                                labelForElement.classList.remove( 'focus-select' );
                                labelForElement.classList.add( 'focus' );
                            } else {
                                labelForElement.classList.add( 'focus-select' );
                                labelForElement.classList.remove( 'focus' );
                            }

                            // Exception for when the default option is called 'Select'
                            if ( formElement.options[ formElement.selectedIndex ].text === 'Select...' ||
                                formElement.options[ formElement.selectedIndex ].text === 'Wählen...'
                            ) {
                                labelForElement.classList.add( 'focus-select' );
                                labelForElement.classList.remove( 'focus' );
                            }

                        }

                    } );

                    let labelForElement = row.querySelector( 'label' );
                    if ( labelForElement ) labelForElement.classList.add( 'focus-select' );

                }

                // Resize small textarea fields to 4 rows
                if ( formElement && formElement.tagName === 'TEXTAREA' ) {
                    if ( formElement.rows <= 4 ) formElement.rows = 4;
                }

                // Style row that has a placeholder and no child form element
                let isPlaceholder = row.querySelector( '.mktoPlaceholder' );
                if ( !formElement && isPlaceholder ) {
                    row.classList.add( 'is-placeholder' );
                }

                const isNewsletter = formContainer === '.ce-newsletter' ? true : false;

                // Style row with a checkbox input
                let hasCheckbox = row.querySelector( 'input[type=checkbox]' );
                if ( hasCheckbox ) {
                    row.classList.add( 'is-checkbox-row' );
                }

                // Style row with a checkbox input in a newsletter element
                if ( isNewsletter && hasCheckbox ) {
                    row.classList.remove( 'is-checkbox-row' );
                    row.classList.add( 'is-checkbox-newsletter-row' );
                    if ( hasCheckbox.classList.contains( 'mktoField' ) ) {
                        hasCheckbox.classList.remove( 'mktoField' );
                    }
                }

                // Style row that has a privacy policy link
                let isPrivacyPolicy = row.querySelector( 'a' );
                if ( isPrivacyPolicy ) {
                    row.classList.add( 'is-privacy-policy' );
                }

                // Style row with a privacy policy link in a newsletter element
                if ( isNewsletter && isPrivacyPolicy ) {
                    row.classList.remove( 'is-privacy-policy' );
                    row.classList.add( 'is-privacy-policy-newsletter' );
                    isPrivacyPolicy.style.color = 'white';
                }

                // Style row with an email input in a newsletter
                let emailField = row.querySelector( '#Email' );
                if ( isNewsletter && emailField ) {
                    row.classList.add( 'is-newsletter-email' );
                }

                // Determine if the following fields are present to style them side by side
                let firstName = row.querySelector( '#FirstName' );
                if ( firstName ) {
                    isFirstName = row;
                    continue;
                }

                let lastName = row.querySelector( '#LastName' );
                if ( lastName ) {
                    isLastName = row;
                    continue;
                }

                let currentErp = row.querySelector( '#new_erpfrom' );
                if ( currentErp ) {
                    isCurrentErp = row;
                    continue;
                }

                let switchingTo = row.querySelector( '#toERP' );
                if ( switchingTo ) {
                    isSwitchingTo = row;
                    continue;
                }

                let seniorityLevel = row.querySelector( '#new_sana_senioritylevel' );
                if ( seniorityLevel ) {
                    isSeniorityLevel = row;
                    continue;
                }

                let department = row.querySelector( '#Department' );
                if ( department ) {
                    isDepartment = row;
                    continue;
                }

            }

            // Style fields side by side when both are present
            if ( isFirstName && isLastName ) {
                isFirstName.classList.add( 'width-50-percent', 'col-left' );
                isLastName.classList.add( 'width-50-percent', 'col-right' );
            }

            if ( isCurrentErp && isSwitchingTo ) {
                isCurrentErp.classList.add( 'width-50-percent', 'col-left' );
                isSwitchingTo.classList.add( 'width-50-percent', 'col-right' );
            }

            if ( isSeniorityLevel && isDepartment ) {
                isSeniorityLevel.classList.add( 'width-50-percent', 'col-left' );
                isDepartment.classList.add( 'width-50-percent', 'col-right' );
            }

        }

        window.addEventListener( 'load', () => {

            const formContainers = [
                    '.ce-forms',
                    '.ce-text-with-media',
                    '.demo-form',
                    '.form-section',
                    '.popup',
                    '.ce-text',
                    '.ce-newsletter'
                ];

            for ( const formContainer of formContainers ) {

                const forms = document.querySelectorAll( formContainer );


                for ( const form of forms ) {

                    const hasFormScript = form.querySelectorAll( 'script' )[ 0 ];

                    
                    if ( !hasFormScript ) continue; // Continue with next form
                    
                    const src = hasFormScript.src || '';
                    if ( !src.includes( 'marketo.com' ) && !src.includes( 'info.sana-commerce.com' ) ) continue; // Not a Marketo script
                    
                    // Setup MutationObserver to watch for Marketo form initialization and changes
                    const callback = function ( mutationsList, observer ) {
                        for ( const mutation of mutationsList ) {
                            if ( mutation.type === 'childList' ) {
                                formSetup( form, formContainer );
                            }
                        }
                    }

                    const observer = new MutationObserver( callback );

                    observer.observe( form, {
                        attributes: true,
                        childList: true,
                        subtree: true
                    } );

                    // Apply styling once on window load
                    formSetup( form, formContainer );

                    // makes a clone of the background image to be used in the confirm message
                    if (form.classList.contains('ce-newsletter')) {
                        const bg = form.querySelector('.background-image');
                        const confirmForm = document.getElementById('confirmform');
                        if (bg && confirmForm) {
                            const bgCopy = bg.cloneNode(true);
                            confirmForm.appendChild(bgCopy);
                        }
                    }

                }

            }

        } )

    }

}

module.exports = FormStyling;
